globalThis.PasswordComplexityMessages = (function() {
  function PasswordComplexityMessages($form) {
    this.$html           = $form;
    this.$passwordInput  = this.$html.find("input[type='password']");
    this.$messages       = this.$html.find(".password-complexity-messages");
    this.nbOfMessages    = this.$messages.find("p").length;
    this.$progressBar    = this.$html.find(".progress-bar");
    this.$submitBtn      = this.$html.find("button[type='submit']");
    this.ajaxUrl         = this.$messages.data("ajax-url");

    if(this.$passwordInput.length && this.ajaxUrl.length) {
      this.init();
    }
  }

  PasswordComplexityMessages.prototype = {
    init: function() {
      this.disableSubmit();
      this.events();
    },
    enabledSubmit: function() {
      this.$submitBtn.removeAttr("disabled");
    },
    disableSubmit: function() {
      this.$submitBtn.attr("disabled", "disabled");
    },
    events: function() {
      var controller = this;

      controller.$passwordInput.on("keyup", function() {
        setTimeout(controller.getData(), 50);
        controller.$messages.show();
      })
    },
    getData: function() {
      var controller = this;

      $.ajax({
        url: controller.ajaxUrl,
        data: { password: controller.$passwordInput.val() },
        success: function(data) {
          if(data.response == 1) {
            controller.setScoreProgress(data.score, data.color);
            controller.setMessages(data.messages);
          } else {
            controller.setScoreProgress(0);
            controller.clearMessages();
          }
        }
      })
    },
    setScoreProgress: function(score, color) {
      this.$progressBar.css("width", `${parseInt(score * 10)}%`);
      if(color) {
        this.$progressBar.css("background-color", `${color}`);
      }
    },
    setMessages: function(messages) {
      var controller = this;
      var validInputsSize = 0;

      $.each(messages, function(k, v) {
        if(v.validity) { validInputsSize += 1; }
        controller.setMessageValidity(k, v.validity);
      })

      if(validInputsSize == controller.nbOfMessages) {
        controller.enabledSubmit();
      } else {
        controller.disableSubmit();
      }
    },
    setMessageValidity(key, validity) {
      var controller = this;

      if(validity) {
        controller.$messages.find(`#${key} i`).removeClass("fa-times text-danger")
        controller.$messages.find(`#${key} i`).addClass("fa-check text-success")
      } else {
        controller.$messages.find(`#${key} i`).removeClass("fa-check text-success")
        controller.$messages.find(`#${key} i`).addClass("fa-times text-danger")
      }
    },
    clearMessages: function() {
      this.$messages.find("i").removeClass("fa-check text-success");
      this.$messages.find("i").addClass("fa-times text-danger");
    }
  }

  return PasswordComplexityMessages;
})();
